/**
 * Die Regeln der Finisherzeile, gerechnet wie im Druck (29.09.2026).
 *
 * Liest window.ffDruckregeln (assets/ff-druckregeln.js), die Datei, die
 * der Generator selbst schreibt (Repo streckenkarte, druckregeln.json).
 * Hier steht nur die Rechnung, keine Zahl: Maße, Grenzen, Zeichen,
 * Laufweiten und Muster kommen alle aus der Datei. Ändert sich der
 * Druck, ändert sich die Datei, und diese Rechnung folgt ohne eigenen
 * Eingriff.
 *
 * Nachgerechnet von pruefung/druckregeln-abgleich.mjs: die Prüffälle der
 * Datei hat der Generator durchgerechnet, dieses Skript muss für jeden
 * dasselbe Ergebnis liefern. Deshalb reine Funktionen ohne DOM.
 *
 * Breite in mm: Summe der Laufweiten (Tausendstel Geviert) mal Grad durch
 * 1000, dazu der Zeichenabstand je Zeichen, alles in Punkt, dann mal
 * 25,4 / 72. So rechnet reportlab (streckenkarte, poster.feld_breite_mm),
 * ohne Kerning. Das canvas des Browsers misst die Webschrift, eine
 * Untermenge mit Kerning: dafür bleibt es nur der Ersatz, wenn diese
 * Datei fehlt (ff-vorschau.js).
 *
 * Ohne ffDruckregeln liefert ffZeilenregeln.bereit() false, alle übrigen
 * Funktionen null. ff-vorschau.js fällt dann auf seine eigenen Werte
 * zurück, die der Abgleich gegen dieselbe Datei hält.
 */
(function (wurzel) {
  'use strict';

  var PT_MM = 25.4 / 72;
  var tabellen = {};
  var leerraum = null;

  function regeln() {
    var r = wurzel.ffDruckregeln;
    return r && r.version === 1 && r.satz && r.felder && r.schriften && r.regeln && r.sprachen ? r : null;
  }

  function bereit() {
    return !!regeln();
  }

  /* Codepunkt zu Laufweite, aus den Läufen [erster Codepunkt, [Breiten]]. */
  function tabelle(schrift) {
    if (tabellen[schrift]) return tabellen[schrift];
    var r = regeln();
    var quelle = r && r.schriften[schrift];
    if (!quelle) return null;
    var t = {};
    for (var i = 0; i < quelle.zeichen.length; i++) {
      var start = quelle.zeichen[i][0];
      var breiten = quelle.zeichen[i][1];
      for (var k = 0; k < breiten.length; k++) t[start + k] = breiten[k];
    }
    tabellen[schrift] = t;
    return t;
  }

  function feldSatz(feld) {
    var r = regeln();
    if (!r || !r.felder[feld]) return null;
    return r.satz[r.felder[feld].satz] || null;
  }

  function codepunkte(text) {
    var aus = [];
    for (var i = 0; i < text.length; ) {
      var punkt = text.codePointAt(i);
      aus.push(punkt);
      i += punkt > 0xffff ? 2 : 1;
    }
    return aus;
  }

  /* NFC, Leerraum wie im Tagesstapel (bereinigen) zu einem Leerzeichen,
     ohne Rand. So geht der Text an die Bestellung. */
  function bereinigt(text) {
    var r = regeln();
    if (!r) return null;
    if (!leerraum) leerraum = new RegExp(r.regeln.zeichen.leerraum_muster + '+', 'g');
    var aus = String(text || '');
    if (aus.normalize) aus = aus.normalize('NFC');
    return aus.replace(leerraum, ' ').replace(/^ +| +$/g, '');
  }

  /* Versalien wie im Druck (poster.versal): vor dem Großschreiben jedes
     Zeichen aus regeln.zeichen.versal_ersatz ersetzen, ß wird ẞ statt SS
     (Lenny, 23.09.2026, A-606). Ohne Datei dieselbe Regel fest. */
  function versal(text) {
    var r = regeln();
    var ersatz = (r && r.regeln.zeichen.versal_ersatz) || { 'ß': 'ẞ' };
    var aus = String(text || '');
    for (var klein in ersatz) {
      if (Object.prototype.hasOwnProperty.call(ersatz, klein)) aus = aus.split(klein).join(ersatz[klein]);
    }
    return aus.toUpperCase();
  }

  /* Der Text, wie der Druck ihn setzt: bereinigt, bei Name und Ort in
     Versalien. */
  function gedruckt(feld, text) {
    var r = regeln();
    if (!r || !r.felder[feld]) return null;
    var aus = bereinigt(text);
    return r.felder[feld].versalien ? versal(aus) : aus;
  }

  /* Das erste Zeichen, wie getippt, das der Druck nicht setzt, sonst ''.
     Geprüft wird die gedruckte Form: ß wird ẞ, und das muss die Schrift
     haben. */
  function fremdesZeichen(feld, text) {
    var satz = feldSatz(feld);
    var t = satz && tabelle(satz.schrift);
    if (!t) return null;
    var r = regeln();
    var einzeln = new RegExp('^' + r.regeln.zeichen.leerraum_muster + '$');
    var roh = String(text || '');
    if (roh.normalize) roh = roh.normalize('NFC');
    var punkte = codepunkte(roh);
    for (var i = 0; i < punkte.length; i++) {
      var zeichen = String.fromCodePoint(punkte[i]);
      /* Leerraum fasst der Druck zusammen, er ist nie das fremde Zeichen. */
      if (einzeln.test(zeichen)) continue;
      var druck = codepunkte(r.felder[feld].versalien ? versal(zeichen) : zeichen);
      for (var k = 0; k < druck.length; k++) {
        if (!(druck[k] in t)) return zeichen;
      }
    }
    return '';
  }

  /* Breite des gedruckten Textes in mm, null bei unbekanntem Zeichen. */
  function breiteMm(feld, text) {
    var satz = feldSatz(feld);
    var t = satz && tabelle(satz.schrift);
    if (!t) return null;
    var druck = codepunkte(gedruckt(feld, text));
    var einheiten = 0;
    for (var i = 0; i < druck.length; i++) {
      if (!(druck[i] in t)) return null;
      einheiten += t[druck[i]];
    }
    return ((einheiten * satz.pt) / 1000 + satz.laufweite_pt * druck.length) * PT_MM;
  }

  function grenzeMm(feld) {
    var r = regeln();
    return r ? r.grenzen_mm[r.felder[feld].grenze] : null;
  }

  /* '' druckbar, 'zeichen' ein Zeichen fehlt im Druck, 'breite' zu
     breit für die Spalte. Dieselben Befunde wie der Tagesstapel
     (streckenkarte, tagesstapel.feld_pruefen). */
  function befund(feld, text) {
    var satz = feldSatz(feld);
    var t = satz && tabelle(satz.schrift);
    if (!t) return null;
    var druck = codepunkte(gedruckt(feld, text));
    for (var i = 0; i < druck.length; i++) {
      if (!(druck[i] in t)) return 'zeichen';
    }
    return breiteMm(feld, text) > grenzeMm(feld) ? 'breite' : '';
  }

  /* Zahl und Label der linken Spalte, aus dem Wert, der als Distanz an
     die Bestellung geht (streckenkarte, tagesstapel.distanz_satz). Ein
     Wort steht in der Sprache des Posters: "Staffel" englisch als RELAY. */
  function distanzSatz(eingabe, spr) {
    var r = regeln();
    if (!r) return null;
    var text = String(eingabe || '');
    var einheiten = r.regeln.einheiten;
    var ultra = new RegExp(r.regeln.ultra.muster).exec(text);
    if (ultra) return { zahl: ultra.groups.zahl, label: einheiten[ultra.groups.einheit] };
    var trail = r.regeln.trail;
    var teile = new RegExp(trail.muster).exec(text);
    if (teile && (teile.groups.zahl || teile.groups.hm)) {
      var zahl = [];
      var label = [];
      if (teile.groups.zahl) {
        zahl.push(teile.groups.zahl);
        label.push(einheiten[teile.groups.einheit] || '');
      }
      if (teile.groups.hm) {
        zahl.push(teile.groups.hm);
        label.push(trail.hoehen[teile.groups.hoehe] || '');
      }
      return { zahl: zahl.join(trail.mittelpunkt), label: label.join(trail.mittelpunkt) };
    }
    if (Object.prototype.hasOwnProperty.call(r.regeln.distanz_km, text)) {
      return { zahl: r.regeln.distanz_km[text], label: r.regeln.distanz_label };
    }
    /* Wort ohne Zahl (Marvin, 30.09.2026): in Versalien, Label leer. Mit
       bekannter Länge steht sie klein darunter, VIERTELMARATHON über
       10,55 KM (Lenny, 30.09.2026). */
    var wort = r.regeln.wort;
    if (Object.prototype.hasOwnProperty.call(wort.mit_laenge, text)) {
      return { zahl: wort.mit_laenge[text].zahl, label: wort.mit_laenge[text].label };
    }
    if (text && !new RegExp(wort.ziffer_muster).test(text)) {
      var worte = r.sprachen[sprache(spr)].worte || {};
      var gesetzt = Object.prototype.hasOwnProperty.call(worte, text) ? worte[text] : text;
      return { zahl: versal(gesetzt), label: wort.label };
    }
    return { zahl: text, label: r.regeln.distanz_label };
  }

  /* Wofür der Distanzwert steht, wie tagesstapel.distanz_art: Ultra mit
     Zahl ist Ultra, Trail mit Angaben (oder eine Strecke mit Einheit) ist
     Trail, sonst der Wert selbst. */
  function distanzArt(eingabe) {
    var r = regeln();
    if (!r) return null;
    var text = String(eingabe || '');
    /* Jede Triathlon-Klasse ist ein Triathlon (tagesstapel.distanz_art). */
    if (triathlonKlasse(text) !== null) return 'Triathlon';
    if (new RegExp(r.regeln.ultra.muster).test(text)) return r.regeln.ultra.wort;
    var teile = new RegExp(r.regeln.trail.muster).exec(text);
    if (teile && (teile.groups.zahl || teile.groups.hm)) return 'Trail';
    return text;
  }


  /* h:mm:ss, Minuten und Sekunden unter 60, nicht 0:00:00. */
  function zielzeitGueltig(text) {
    var r = regeln();
    if (!r) return null;
    var z = r.regeln.zielzeit;
    var teile = new RegExp(z.muster).exec(String(text || ''));
    if (!teile) return false;
    var h = +teile[1];
    var m = +teile[2];
    var s = +teile[3];
    if (m > z.max_minute || s > z.max_sekunde) return false;
    return !(z.null_verboten && h === 0 && m === 0 && s === 0);
  }

  /* Sprache des Posters aus einer Sprachangabe wie "de", "en" oder
     "en-GB", wie der Tagesstapel sie aus customerLocale der Bestellung
     liest (streckenkarte, poster.sprache_aus). Unbekannt heißt die
     Standardsprache der Datei. */
  function sprache(locale) {
    var r = regeln();
    if (!r) return null;
    var kurz = String(locale || '')
      .trim()
      .toLowerCase()
      .replace(/_/g, '-')
      .split('-')[0];
    return Object.prototype.hasOwnProperty.call(r.sprachen, kurz) ? kurz : r.sprache_standard;
  }

  /* Sprache der Finisherzeile einer Position wie der Tagesstapel
     (streckenkarte, tagesstapel.sprache_der_position): die gewählte
     Eigenschaft Sprache ("Deutsch", "English") vor der Sprache der
     Bestellung, ohne Eigenschaft die Locale. null, wenn die Eigenschaft
     einen Wert trägt, den der Druck nicht kennt (Marvin, 01.10.2026). */
  function spracheDerPosition(eigenschaft, locale) {
    var r = regeln();
    if (!r) return null;
    var e = r.regeln.sprache_eigenschaft;
    if (!e || eigenschaft === null || eigenschaft === undefined || eigenschaft === '') return sprache(locale);
    return Object.prototype.hasOwnProperty.call(e.werte, eigenschaft) ? e.werte[eigenschaft] : null;
  }

  /* Die Beschriftung rechts je Sprache: { zeit: 'ZEIT', datum: 'DATUM' }. */
  function beschriftung(spr) {
    var r = regeln();
    if (!r) return null;
    var w = r.sprachen[sprache(spr)];
    return { zeit: w.zeit, datum: w.datum };
  }

  /* TT.MM.JJJJ zu [kurz, lang] wie der Tagesstapel, sonst null. Das
     Langdatum in der Sprache der Bestellung. */
  function lauftag(text, spr) {
    var r = regeln();
    if (!r) return null;
    var teile = new RegExp(r.regeln.lauftag.muster).exec(String(text || '').trim());
    if (!teile) return null;
    var tag = +teile[1];
    var monat = +teile[2];
    var jahr = +teile[3];
    var d = new Date(Date.UTC(jahr, monat - 1, tag));
    if (jahr < 1 || d.getUTCFullYear() !== jahr || d.getUTCMonth() !== monat - 1 || d.getUTCDate() !== tag) return null;
    var w = r.sprachen[sprache(spr)];
    var lang = w.datum_lang
      .replace('{tag}', String(tag))
      .replace('{monat}', w.monate[monat - 1])
      .replace('{jahr}', String(jahr));
    return [teile[1] + '.' + teile[2] + '.' + teile[3], lang];
  }

  /* Lage und Satz in mm ab der Fensteroberkante, für Zeichnung und Bild. */
  function lage() {
    var r = regeln();
    if (!r) return null;
    var grad = {};
    var lauf = {};
    for (var name in r.satz) {
      if (!Object.prototype.hasOwnProperty.call(r.satz, name)) continue;
      grad[name] = r.satz[name].grad_mm;
      lauf[name] = r.satz[name].laufweite_mm;
    }
    return {
      fenster: r.fenster_mm,
      poster: r.poster_mm,
      spalten: r.spalten_mm,
      linie: r.linie,
      vorlagen: r.vorlagen,
      grad: grad,
      lauf: lauf,
      grenzen: r.grenzen_mm
    };
  }

  /* ---------- Triathlon, Zeile H2 (Marvin, 26.10.2026) ----------
     Eigenes Passepartout mit dem Fenster 320 x 60 mm. Die Datei trägt
     dafür einen eigenen Block h2 (streckenkarte, druckregeln.h2): Lage
     in mm ab Oberkante und linker Kante des H2-Fensters, Satz je Rolle,
     Grenzen, Farben der Balken und die Schlüssel der Teilzeiten. Ohne
     den Block liefern alle h2-Funktionen null. */
  function h2() {
    var r = regeln();
    return r && r.h2 && r.h2.satz && r.h2.grenzen_mm ? r.h2 : null;
  }

  /* Welcher Satz zu welchem Feld gehört (poster.draw_zeile_h2): Name und
     Datum im Kopfsatz, der Ort groß, darunter Beschriftung und Zeit je
     Spalte. */
  var H2_SATZ = { name: 'kopf', datum: 'kopf', ort: 'ort', label: 'label', zeit: 'zeit' };
  /* Die Grenze je Feld: Name und Ort eigene, Beschriftung und Zeit die
     Spaltenbreite. Das Datum hat keine, es ist immer TT.MM.JJJJ. */
  var H2_GRENZE = { name: 'name', ort: 'ort', label: 'spalte', zeit: 'spalte' };

  function h2Satz(feld) {
    var b = h2();
    return b && H2_SATZ[feld] ? b.satz[H2_SATZ[feld]] || null : null;
  }

  /* Der Text, wie der Druck ihn in der Zeile H2 setzt: Name und Ort in
     Versalien (tagesstapel.feld_pruefen mit poster.versal), der Rest
     bereinigt wie getippt. */
  function h2Gedruckt(feld, text) {
    if (!h2()) return null;
    var aus = bereinigt(text);
    return feld === 'name' || feld === 'ort' ? versal(aus) : aus;
  }

  /* Breite in mm wie breiteMm, im Satz der Zeile H2. pt wählt eine
     Stufe (h2Stufe), ohne pt gilt der Grad aus dem Satz, die erste Stufe. */
  function h2BreiteMm(feld, text, pt) {
    var satz = h2Satz(feld);
    var t = satz && tabelle(satz.schrift);
    if (!t) return null;
    var druck = codepunkte(h2Gedruckt(feld, text));
    var einheiten = 0;
    for (var i = 0; i < druck.length; i++) {
      if (!(druck[i] in t)) return null;
      einheiten += t[druck[i]];
    }
    var grad = typeof pt === 'number' ? pt : satz.pt;
    return ((einheiten * grad) / 1000 + satz.laufweite_pt * druck.length) * PT_MM;
  }

  /* Die Stufen eines Felds in pt (Marvin, 27.10.2026, h2.stufen_pt):
     Name und Ort werden kleiner gesetzt, bis sie in ihre Grenze passen.
     Alle anderen Felder haben nur den Grad ihres Satzes. */
  function h2Stufen(feld) {
    var b = h2();
    var satz = h2Satz(feld);
    if (!b || !satz) return [];
    var stufen = b.stufen_pt && b.stufen_pt[feld];
    return stufen && stufen.length ? stufen.slice() : [satz.pt];
  }

  /* Der Grad in pt, in dem der Druck das Feld setzt (poster.h2_satz):
     die erste Stufe, mit der es in die Grenze passt. null, wenn auch die
     kleinste nicht passt, ein Zeichen fehlt oder die Datei fehlt. */
  function h2Stufe(feld, text) {
    var b = h2();
    var stufen = h2Stufen(feld);
    var grenze = b && H2_GRENZE[feld] ? b.grenzen_mm[H2_GRENZE[feld]] : null;
    for (var i = 0; i < stufen.length; i++) {
      var breite = h2BreiteMm(feld, text, stufen[i]);
      if (breite === null) return null;
      if (!grenze || breite <= grenze) return stufen[i];
    }
    return null;
  }

  /* '', 'zeichen' oder 'breite', wie der Tagesstapel für Name und
     Ortszeile einer Position mit Teilzeiten: 'breite' erst, wenn auch
     die kleinste Stufe nicht passt (tagesstapel.h2_feld_pruefen). */
  function h2Befund(feld, text) {
    var satz = h2Satz(feld);
    var t = satz && tabelle(satz.schrift);
    if (!t) return null;
    var druck = codepunkte(h2Gedruckt(feld, text));
    for (var i = 0; i < druck.length; i++) {
      if (!(druck[i] in t)) return 'zeichen';
    }
    return h2Stufe(feld, text) === null ? 'breite' : '';
  }

  /* Das Datum der Zeile H2 aus TT.MM.JJJJ (poster.datum_h2, h2.datum):
     deutsch unverändert, englisch "5 JUL 2026". Was nicht TT.MM.JJJJ ist,
     bleibt, wie es ist. */
  function h2Datum(kurz, spr) {
    var b = h2();
    var text = String(kurz || '');
    var m = /^([0-9]{2})\.([0-9]{2})\.([0-9]{4})$/.exec(text);
    if (!b || !b.datum || !m) return text;
    var w = b.datum.sprachen[sprache(spr)] || b.datum.sprachen[regeln().sprache_standard];
    var monat = +m[2];
    if (!w || monat < 1 || monat > 12) return text;
    var werte = { tt: m[1], mm: m[2], jjjj: m[3], tag: String(+m[1]), monat: w.monate.length ? w.monate[monat - 1] : '' };
    return w.format.replace(/\{(tt|mm|jjjj|tag|monat)\}/g, function (_, k) {
      return werte[k];
    });
  }

  /* Alle Triathlon-Distanzen (Marvin, 26.10.2026). Die Distanz heißt
     "Triathlon <Klasse>" (h2.distanz_muster, h2.klassen). Liefert die
     Klasse, '' für das alte "Triathlon" ohne Klasse, null für alles
     andere (tagesstapel.triathlon_klasse). */
  function triathlonKlasse(text) {
    var b = h2();
    if (!b || !b.distanz_muster) return null;
    var m = new RegExp(b.distanz_muster).exec(String(text || ''));
    return m ? m[1] || '' : null;
  }

  /* Eine Strecke in km, wie der Tagesstapel sie liest (km_aus_bestellung):
     h2.km_muster, also Komma, höchstens zwei Stellen dahinter, und größer 0. */
  function kmGueltig(text) {
    var b = h2();
    if (!b || !b.km_muster) return null;
    var s = String(text || '');
    return new RegExp(b.km_muster).test(s) && parseFloat(s.replace(',', '.')) > 0;
  }

  /* km mit Komma, Nullen hinter dem Komma weg (tagesstapel.km_summe):
     gerechnet in Hundertsteln, damit 0,75 + 20 + 5 genau 25,75 ergibt. */
  function kmText(hundertstel) {
    var ganz = Math.floor(hundertstel / 100);
    var rest = String(hundertstel % 100 + 100).slice(1).replace(/0+$/, '');
    return String(ganz) + (rest ? ',' + rest : '');
  }

  function kmHundertstel(text) {
    var teile = /^(\d+)(?:,(\d{1,2}))?$/.exec(String(text || ''));
    if (!teile) return null;
    return +teile[1] * 100 + +((teile[2] || '') + '00').slice(0, 2);
  }

  /* Die Beschriftung der Zeile H2 aus den km je Disziplin
     (tagesstapel.triathlon_beschriftung): { spalten: [SWIM · 1,9 KM, ...],
     finish: FINISH · 113 KM }. null, wenn eine Strecke keine ist. */
  function h2Beschriftung(km) {
    var b = h2();
    if (!b || !b.teil_wort || !km || km.length !== 3) return null;
    var arten = ['swim', 'bike', 'run'];
    var spalten = [];
    var summe = 0;
    for (var i = 0; i < 3; i++) {
      var h = kmGueltig(km[i]) ? kmHundertstel(km[i]) : null;
      if (h === null) return null;
      summe += h;
      spalten.push(b.teil_wort[arten[i]] + ' · ' + kmText(h) + ' KM');
    }
    return { spalten: spalten, finish: 'FINISH · ' + kmText(summe) + ' KM' };
  }

  /* h:mm:ss in Sekunden (tagesstapel.sekunden), null, wenn die Zeit
     nach regeln.zielzeit keine ist. Die Summe der Teilzeiten liegt nie
     über der Gesamtzeit, dazwischen liegen die Wechsel. */
  function sekunden(text) {
    if (!zielzeitGueltig(text)) return null;
    var teile = new RegExp(regeln().regeln.zielzeit.muster).exec(String(text));
    return +teile[1] * 3600 + +teile[2] * 60 + +teile[3];
  }

  wurzel.ffZeilenregeln = {
    h2: h2,
    h2Gedruckt: h2Gedruckt,
    h2BreiteMm: h2BreiteMm,
    h2Stufe: h2Stufe,
    h2Befund: h2Befund,
    h2Datum: h2Datum,
    triathlonKlasse: triathlonKlasse,
    kmGueltig: kmGueltig,
    h2Beschriftung: h2Beschriftung,
    sekunden: sekunden,
    bereit: bereit,
    bereinigt: bereinigt,
    versal: versal,
    gedruckt: gedruckt,
    fremdesZeichen: fremdesZeichen,
    breiteMm: breiteMm,
    grenzeMm: grenzeMm,
    befund: befund,
    distanzSatz: distanzSatz,
    distanzArt: distanzArt,
    zielzeitGueltig: zielzeitGueltig,
    sprache: sprache,
    spracheDerPosition: spracheDerPosition,
    beschriftung: beschriftung,
    lauftag: lauftag,
    lage: lage
  };
})(typeof window !== 'undefined' ? window : globalThis);
